import * as THREE from "three";
import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { FBXLoader } from 'three/addons/loaders/FBXLoader.js';
export default function Contentscene(scenepath, loadingmanager) {

    let scene, animations;
    function init() {
        scene = new THREE.Scene();
        const loader = new GLTFLoader(loadingmanager);
        loader.loadAsync(scenepath, function (gltf) {
        }).then((val) => {
            scene.add(val.scene)
           scene.reel = val.animations

            console.log(scene)
            if (val.scene) {
                for (let i = 0; i < val.scene.children.length; i++) {
                    if (val.scene.children[i].isCamera){
                        console.log(val.scene.children[i])
                        scene.camera = val.scene.children[i]
                    }
                }

            }

        })
       
        
    }
    function animate() {
  
        requestAnimationFrame(animate);
    }
    animate()
    init()
    return scene


}